import React from "react";
import "./PrivacyPolicy.css"; // reuse same layout styles

export default function Imprint() {
  return (
    <div className="privacy-page">
      <div className="privacy-wrapper">
        <div className="privacy-container">
          <h1>Imprint (Impressum)</h1>

          <p className="address">
            David Psiuk<br />
            c/o MDC Management #5259<br />
            Welserstraße 3<br />
            87463 Dietmannsried<br />
            Germany
          </p>

          <p>
            <strong>Email:</strong><br />
            <a href="mailto:contact@aprendole.com">
              contact@aprendole.com
            </a>
          </p>

          <h2>EU Online Dispute Resolution (OS Platform)</h2>
          <p>
            The European Commission provides a platform for online dispute
            resolution (OS):<br />
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noreferrer"
            >
              https://ec.europa.eu/consumers/odr
            </a>
          </p>

          <h2>Consumer Dispute Resolution (§ 36 VSBG)</h2>
          <p>
            We are neither obligated nor willing to participate in dispute
            resolution proceedings before a consumer arbitration board.
          </p>
        </div>
      </div>
    </div>
  );
}

